"use strict";
(self["webpackChunkheraclea_olive_oil"] = self["webpackChunkheraclea_olive_oil"] || []).push([[870],{

/***/ 870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ menuDesktop)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(880);
// components/menu.js




function menuDesktop({ wrapper }) {
  const { classes } = window.config

  // Cache finds the triggers based on what is set to toggle the wrapper
  const cache = {
    cards: wrapper.querySelectorAll('[data-hook="menu-link"] [data-hook="menu-card"]'),
  }

  // Init Menu
  ;(function init() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).onClassChange(classes.active, toggle)
  })()

  // Popup Events
  function toggle(hasClass) {
    hasClass ? open() : close()
  }

  function open() {
    const timeline = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Ay.timeline()

    timeline.set(cache.cards, { opacity: 0, autoAlpha: 0 })

    timeline
      .set(wrapper, {
        opacity: 0,
        autoAlpha: 0,
        scaleY: 0,
        display: 'flex',
      })
      .to(wrapper, {
        opacity: 1,
        autoAlpha: 1,
        scaleY: 1,
        duration: 0.3,
        ease: 'power1.in',
      })
      .to(
        cache.cards,
        {
          opacity: 1,
          autoAlpha: 1,
          stagger: 0.1,
          duration: 0.2,
          ease: 'back.out',
        },
        '0.3'
      )
  }

  function close() {
    const timeline = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Ay.timeline()

    timeline
      .to(cache.cards, { opacity: 0, duration: 0.15 })
      .to(
        wrapper,
        {
          duration: 0.075,
          opacity: 0,
          scaleY: 0,
          ease: 'power1.in',
        },
        '0.15'
      )
      .set(wrapper, {
        display: 'none',
        translateY: 0,
        opacity: 1,
        scaleY: 1,
      })
  }
}


/***/ })

}]);